import { SpinnerSize } from '@fluentui/react';
import { FontWeights } from '@fluentui/react';
export function getSpinnerStyles(props) {
    var theme = props.theme, size = props.size;
    var styles = {
        label: [theme.fonts.mediumPlus, { color: theme.semanticColors.bodyText, fontWeight: FontWeights.semibold }],
        circle: [
            {
                borderWidth: 3,
            },
            size === SpinnerSize.large && {
                height: 36,
                width: 36,
            },
            size === SpinnerSize.medium && {
                // default
                height: 32,
                width: 32,
            },
            size === SpinnerSize.small && {
                height: 28,
                width: 28,
            },
            size === SpinnerSize.xSmall && {
                height: 24,
                width: 24,
            },
        ],
    };
    return styles;
}
//# sourceMappingURL=Spinner.styles.js.map